import { OnlineSearchState } from './types';

const INITIAL_STATE: OnlineSearchState = {
  onlineSearch: {
    filters: {
      updated: false,
      id: '',
      uasg: '',
      publicBodyTypes: [],
      processNumber: '',
      object: '',
      note: '',
      address: '',
      publicBody: '',
      itens: '',
      noticeNumber: '',
      includeDateRange: { from: null, to: null },
      deadlineDateRange: { from: null, to: null },
      states: [],
      region: null,
      cities: [],
      modalities: [],
      situation: null,
      exact_search: false,
      national: false,
      international: false,
      validities: false,
      hasNotice: false,
      hasMonitored: false,
      onlyMatch: false,
      monitoredPortals: [],
      activities: [],
      geoType: 'estado',
      radius: 10000,
    },
    currentPage: 1,
    postsPerPage: 20,
    filterActive: {
      id: 0,
      name: '',
    },
    state_from_panel: [],
    orderedBy: '',
    orderDirection: 'desc',
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

export default INITIAL_STATE;
